<script setup lang="ts">
import { type AuctionItemEntity, type AuctionListingItemEntity, AuctionState } from '~/apiClient';

// PROPS
interface Props {
    auction: AuctionListingItemEntity | AuctionItemEntity;
    labelClass?: string;
    countdownClass?: string;
}

const { auction, countdownClass } = defineProps<Props>();

const { tt } = useTypedI18n();

const isPending = computed(() => auction.state === AuctionState.Pending);

const countDownExpiresAt = computed(() => (isPending.value ? auction.startAt : auction.expiresAt));

const { totalSeconds } = useCountdown(countDownExpiresAt);

const classes = computed(() => {
    let textStyleClass = 'text-primary';

    if (auction.state === AuctionState.Running && totalSeconds.value < 60) {
        textStyleClass = 'text-error-500 animate-tick';
    } else if (auction.state === AuctionState.Running && totalSeconds.value < 60 * 15) {
        textStyleClass = 'text-warning-500';
    }

    return [textStyleClass, countdownClass];
});
</script>

<template>
    <span v-if="totalSeconds > 0">
        <span :class="labelClass">{{ tt(isPending ? 'countdown.startsIn' : 'countdown.endsIn') }}:&nbsp;</span>
        <BaseCountdown v-if="countDownExpiresAt" :class="classes" :expires-at="countDownExpiresAt" />
    </span>
</template>
